import React, { useContext } from 'react';
import { connect } from 'react-redux';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import LeadsContext from '@/modules/leads/contexts/LeadsContext';
import RegExpField from '@/modules/common/components/RegExpField';
import DateRangeField from '@/modules/common/components/DateRangeField';
import SelectStatusInternal from '@/modules/common/components/SelectStatusInternal';
import AutocompleteTypeNameField from '@/modules/common/components/AutocompleteTypeNameField';
import AutocompleteMultilineField from '@/modules/common/components/AutocompleteMultilineField';
import { withRouter } from '~/hocs/router';

function getAffiliates(affiliates, offerName) {
    let result = [];
    if (offerName) {
        offerName.split('||').forEach((name) => {
            affiliates.forEach((affiliate) => {
                if (affiliate.offer_name === name && !result.includes(affiliate.affiliate_name)) {
                    result.push(affiliate.affiliate_name);
                }
            });
        });
    }
    else {
        offerName.split('||').forEach(() => {
            affiliates.forEach(({affiliate_name,}) => {
                if (!result.includes(affiliate_name)) {
                    result.push(affiliate_name);
                }
            });
        });
    }
    return result.sort();
}

function getTypes(types, offerName) {
    let results = [];
    if (offerName) {
        offerName.split('||').forEach((name) => {
            types.forEach((type) => {
                if (type.offer.offer_name === name && !results.includes(type)) {
                    results.push(type);
                }
            });
        });
    }
    else {
        results = [...types];
    }
    return results;
}

const RowFilter = (props) => {
    const offerName = props.router.getUrlSearchParam('offer_name');

    // noinspection JSCheckFunctionSignatures
    const leadsContext = useContext(LeadsContext);
    const cols = leadsContext.cols;
    const values = leadsContext.valuesFilter;
    const setValues = leadsContext.setValuesFilter;
    const affiliates = leadsContext.affiliates;

    return (
        <TableRow className="table-row-filter">
            <TableCell className="adv_sub">
                <RegExpField value={values.advSub}
                             onChange={(event) => setValues({...values, advSub: event.target.value})}
                             inputProps={{form: 'form-filter'}}
                />
            </TableCell>
            <TableCell className="offer">
                <AutocompleteMultilineField options={props.cfgOffers.map((cfgOffer) => cfgOffer.offer_name)}
                                            value={values.offerName}
                                            setValue={(value) => setValues({...values, offerName: value})}
                />
            </TableCell>
            {(!props.user.affiliate)
                ? <TableCell className="affiliate_name">
                    <AutocompleteMultilineField options={getAffiliates(affiliates, offerName)}
                                                value={values.affiliateName}
                                                setValue={(value) => setValues({...values, affiliateName: value})}
                    />
                </TableCell>
                : null
            }
            {(cols.type)
                ? <TableCell className="type">
                    <AutocompleteTypeNameField types={getTypes(props.types, offerName)}
                                               value={values.typeName}
                                               setValue={(value) => setValues({...values, typeName: value})}
                                               showLabel={false}
                    />
            </TableCell>
                : null
            }
            <TableCell className="datetime">
                <DateRangeField value={values.date} setValue={(value) => setValues({...values, date: value})}/>
            </TableCell>
            <TableCell className="source">
                <RegExpField value={values.source}
                             onChange={(event) => setValues({...values, source: event.target.value})}
                             inputProps={{form: 'form-filter'}}
                />
            </TableCell>
            <TableCell className="aff_sub">
                <RegExpField value={values.affSub}
                             onChange={(event) => setValues({...values, affSub: event.target.value})}
                             inputProps={{form: 'form-filter'}}
                />
            </TableCell>
            {(cols.advSub2)
                ? <TableCell>
                    <RegExpField value={values.advSub2}
                                 onChange={(event) => setValues({...values, advSub2: event.target.value})}
                                 inputProps={{form: 'form-filter'}}
                    />
                </TableCell>
                : null
            }
            {(cols.dts)
                ? <TableCell className="datetime_status">
                    <DateRangeField value={values.dateStatus}
                               setValue={(value) => setValues({...values, dateStatus: value})}
                    />
                </TableCell>
                : null
            }
            <TableCell className="status">
                <SelectStatusInternal showLabel={false}
                                      value={values.statusInternal}
                                      onChange={(event) => setValues({...values, statusInternal: event.target.value})}
                />
            </TableCell>
            <TableCell className="price"/>
            {(leadsContext.cols.transactionId)
                ? <TableCell className="transaction_id">
                    <RegExpField value={values.transactionId}
                                 onChange={(event) => setValues({...values, transactionId: event.target.value})}
                                 inputProps={{form: 'form-filter'}}
                    />
                </TableCell>
                : null
            }
        </TableRow>
    );
};

let Component = RowFilter;
Component = withRouter(Component);

export default connect(
    (state) => ({
        types: state.types,
        user: state.auth.user,
        cfgOffers: state.cfg.offers,
        affiliates: state.affiliates,
    }),
    null
)(Component);
